<template>
  <div class="page-wrapper">
    <!-- Tabs Wrapper -->
    <div class="tabs-wrapper">
      <b-tabs v-if="getUserBrandPermissions.kpi_devices" lazy>
        <b-tab title="Highlights" active>
          <ulu-highlights />
        </b-tab>
        <b-tab title="Details">
          <ulu-details />
        </b-tab>
        <b-tab title="Parkings" v-if="getUserSystem.toLowerCase() == 'ulu'">
          <ulu-parkings />
        </b-tab>
        <b-tab title="Agents">
          <ulu-agents />
        </b-tab>
        <b-tab title="Finance" v-if="getUserBrandPermissions.kpi_finance">
          <ulu-finance />
        </b-tab>
        <b-tab title="Devices">
          <ulu-devices />
        </b-tab>
        <b-tab title="Customers">
          <ulu-customers />
        </b-tab>
        <b-tab title="Subscriptions (beta)">
          <ulu-subscriptions />
        </b-tab>
        <b-tab title="Inquiry/Order">
          <ulu-inquiry-order />
        </b-tab>
        <b-tab title="Revenue">
          <ulu-revenue-stats />
        </b-tab>
        <b-tab v-if="getUserSystem.toLowerCase() == 'national_netherlands'" title="Ohra">
          <ulu-ohra-stats />
        </b-tab>
        <b-tab title="Overview">
          <ulu-overview />
        </b-tab>
        <b-tab title="Stock">
          <ulu-stock />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    "ulu-highlights": () =>
      import("@/components/dashboard/highlights/Highlights"),
    "ulu-details": () => import("@/components/dashboard/details/Details"),
    "ulu-finance": () => import("@/components/dashboard/finance/Finance"),
    "ulu-agents": () => import("@/components/dashboard/agents/Agents"),
    "ulu-parkings": () => import("@/components/dashboard/parkings/Parkings"),
    "ulu-devices": () => import("@/components/dashboard/devices/Devices"),
    "ulu-customers": () => import("@/components/dashboard/customers/Customers"),
    "ulu-subscriptions": () => import("@/components/dashboard/churn/Subscriptions"),
    "ulu-inquiry-order": () => import("@/components/dashboard/inquiry_order/InquiryOrder"),
    "ulu-ohra-stats": () => import("@/components/dashboard/ohra/Statistics"),
    "ulu-revenue-stats": () => import("@/components/dashboard/revenue/FinanceItemsRevenue"),
    "ulu-overview": () =>
      import("@/components/dashboard/overview/Overview"),
    "ulu-stock": () =>
      import("@/components/dashboard/stock/Stock"),
  },
  computed: {
    ...mapGetters([
      "getUserBrandPermissions",
      "getUserSystem"
    ])
  }
};
</script>
